import { MyPortfolioCapsulesWidgetConfigState } from 'widgets/myPortfolioCapsules/store/config/MyPortfolioCapsulesWidgetConfigState';
import React from 'react';
import './MyPortfolioCapsulesCapsule.scss';
import { MyPortfolioCapsulesCapsuleHeader } from 'widgets/myPortfolioCapsules/components/capsule/MyPortfolioCapsulesCapsuleHeader';
import 'widgets/tiles/components/styles/styles.scss';
import { MyPortfolioCapsuleWidgetStrategy } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';

export interface MyPortfolioCapsulesCapsuleProps {
    config: MyPortfolioCapsulesWidgetConfigState;
    symbol: string;
    symbology: SymbologyValues;
    qty: number;
    qtyRemaining: number;
    value: number;
    strategy: MyPortfolioCapsuleWidgetStrategy;
}

const useNullMessages = () => [];

/*
 * This is an individual capsule within a MyPortfolioCapsules widget
 */
export function MyPortfolioCapsulesCapsule(
    props: MyPortfolioCapsulesCapsuleProps
) {
    const { symbol, symbology, strategy, qty, qtyRemaining } = props;

    const {
        title,
        myPortfolioCapsuleContentReactComponentType: CapsuleComponent,
        myPortfolioCapsuleTitleReactComponentType: titleComponent,
        wideTitle,
    } = strategy;

    const useMessagesInMyPortfolioCapsules =
        strategy.useMessagesInMyPortfolioCapsules ?? useNullMessages;
    const messages = useMessagesInMyPortfolioCapsules(symbol, symbology, qty);

    return (
        <div className="MyPortfolioCapsulesCapsule capsule">
            <MyPortfolioCapsulesCapsuleHeader
                symbol={symbol}
                symbology={symbology}
                qty={qty}
                qtyRemaining={qtyRemaining}
                title={title}
                titleComponent={titleComponent}
                messages={messages}
                wideTitle={wideTitle}
            />
            <div className="capsule-body value">
                <CapsuleComponent
                    symbol={symbol}
                    symbology={symbology}
                    qty={qty}
                    qtyRemaining={qtyRemaining}
                />
            </div>
        </div>
    );
}
